/**
 * @generated SignedSource<<3066317697c85c33a47e5434323bc75d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountDelegatedAuthsId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountDelegatedAuthsId",
    "variableName": "accountDelegatedAuthsId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appData",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "environment",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreshBooksSetupFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDelegatedAuthsT",
        "kind": "LinkedField",
        "name": "accountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreshBooksSetupFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDelegatedAuthsT",
        "kind": "LinkedField",
        "name": "accountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c5b71bbe2223ffab2da786e37b6360ab",
    "id": null,
    "metadata": {},
    "name": "FreshBooksSetupFetchQuery",
    "operationKind": "query",
    "text": "query FreshBooksSetupFetchQuery(\n  $accountDelegatedAuthsId: UUID!\n) {\n  accountDelegatedAuthsTByAccountDelegatedAuthsId(accountDelegatedAuthsId: $accountDelegatedAuthsId) {\n    appName\n    authType\n    appData\n    environment\n    effectiveDate\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "ded4d3284a0fd3674c7b4f953568ac82";

module.exports = node;
